import {env} from '@/helper/env';
import {sd} from '@/da';
import {createGoogleCaptcha} from './google';

export const doCaptcha = (function () {
  let captcha = null;
  /**
   * @returns {Promise<{recaptchaVersion: 1, recaptchaToken: string}>}
   */
  return async function (business_type) {
    const platform = env.isMobile ? 'h5' : 'web';
    if (!captcha) {
      try {
        captcha = await createGoogleCaptcha();
      } catch (e) {
        console.warn('create captcha error:', e);
      }
      sd.track('choose_captcha_way', {verify_type: captcha ? captcha.type : 'nothing', business_type, platform});
      if (!captcha) {
        return null;
      }
    }
    const captchaResult = await captcha.show(business_type);
    sd.track('last_captcha_way', {verify_type: captcha.type, business_type, platform});
    return captchaResult;
  };
})();
